<template>
  <div>
    <div class="company" :class="padding && 'p-4'">
      <h2>{{ model.name }}</h2>
      <div class="company__info p-0">
        <div class="mb-3">
          <p class="mb-0">{{ i18n.app.common.address }}:</p>
          {{ this.getAddress() }}
        </div>

        <div class="mb-3">
          <p class="mb-0">{{ i18n.app.common.contact }}:</p>
          {{ model.phone }}
        </div>

        <div v-if="model.opening_hours_per_day">
          {{ i18n.app.opening_hours.plural }}:
          <DepotOpeningHoursItem :models="model.opening_hours_per_day" />
        </div>

        <div class="mb-3">{{ model.opening_hours_remark }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import DepotOpeningHoursItem from "./DepotOpeningHoursItem";
export default {
  name: "depot-info-item",
  props: ["model", "padding"],
  components: {
    DepotOpeningHoursItem
  },
  methods: {
    getAddress() {
      return (
        this.model.address.street +
        " " +
        this.model.address.house_number +
        ", " +
        this.model.address.zip_code +
        " " +
        this.model.address.city
      );
    }
  }
};
</script>
